import * as util from "lib/util.js";
import { Router } from "@vaadin/router";
import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@vaadin/vaadin-split-layout/vaadin-split-layout.js";
import PubSub from "pubsub-js";
import "./kb-toc.js";
import "./kb-ipc-topic.js";

/**
 * @param {String} kbrid - used to set state of toc tree
 */
class KbIpc extends LitElement {
  constructor() {
    super();

    // PubSub listens for messages from 3D viewer and disables scrolling
    // as necessary
    PubSub.subscribe("3dViewerMouseEnter", (msg) => {
      const rightside = this.shadowRoot.getElementById("rightside");
      rightside.addEventListener("wheel", this.preventScroll);
    });

    PubSub.subscribe("3dViewerMouseLeave", (msg) => {
      const rightside = this.shadowRoot.getElementById("rightside");
      rightside.removeEventListener("wheel", this.preventScroll);
    });
  }

  // for 3D; prevents scroll when mouse is inside viewer
  preventScroll(e) {
    e.preventDefault();
    e.stopPropagation();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.addEventListener(
      "tocItemClicked",
      this._handleTocItemClicked.bind(this)
    );
    this.addEventListener(
      "topicLinkClicked",
      this._handleTocTopicLinkClicked.bind(this)
    );
    this.addEventListener(
      "crossLinkClicked",
      this._handleCrossLinkClicked.bind(this)
    );
    if (this.state.item) {
      this.refreshData();
      storeInstance.dispatch("getParentPath", { extId: this.locationExtId });
    }
    if (this.searchitem) {
      storeInstance.dispatch("getHelpsetTOC", {
        externalId: this.searchitem,
        langCode: this.state.langCode,
      });
    }
  }

  refreshData() {
    storeInstance.dispatch("getHelpsetTOC", {
      externalId: this.state.item.item.externalId,
      langCode: this.state.langCode,
    });
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  _handleTocItemClicked(e) {
    var node = e.detail;
    this.searchitem = null;
    if (this._isCurrentItem(node.href)) {
      this.selectedNode = node;
      history.pushState(
        null,
        null,
        "/kb/" +
          this.state.langCode +
          "/" +
          this.locationExtId +
          "/" +
          node.href
      );
      this.kbrid = node.href;
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: node,
      });
      //this._setSelected(this.rootnode, this.kbrid);
    } else {
      /*hmmm might need to deduce ITEM TYPE from the node.href */
      Router.go(
        "/kb/" +
          this.state.langCode +
          "/" +
          this.state.item.item.externalId +
          "/" +
          node.href
      );
    }
  }

  _handleTocTopicLinkClicked(e) {
    if (this._isCurrentItem(e.detail)) {
      history.pushState(
        null,
        null,
        "/kb/" + this.state.langCode + "/" + locationExtId + "/" + e.detail
      );
      this.kbrid = e.detail;
      this._setSelected(this.rootnode, this.kbrid);
      storeInstance.dispatch("touch");
    }
  }

  _handleCrossLinkClicked(e) {
    Router.go(e.detail.replace("http://", ""));
  }

  _isCurrentItem(href) {
    var aTmp = href.split("~");
    if (aTmp.length > 0) {
      if (aTmp[2] == this.state.item.item.externalId) {
        return true;
      }
    }
    return false;
  }

  removeFilter() {
    for (var i = 0; i < this.rootnode.nodes[0].nodes.length; i++) {
      if (this.rootnode.nodes[0].nodes[i].hasOwnProperty("filtered")) {
        delete this.rootnode.nodes[0].nodes[i].filtered;
      }
    }
  }

  applyFilter() {
    try {
      for (var i = 0; i < this.rootnode.nodes[0].nodes.length; i++) {
        if (this.rootnode.nodes[0].nodes[i].hasOwnProperty("title")) {
          this.rootnode.nodes[0].nodes[i].filtered =
            this.rootnode.nodes[0].nodes[i].title.includes(
              this.state.filter_term.filterterm
            );
        }
      }
    } catch (err) {}
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.filterTerm = "";
    if (this.state.filter_term) {
      this.filterTerm = this.state.filter_term.filterterm;
    }
    if (this.state.item_toc) {
      if (!this.rootnode) {
        this.kbrid = this.kbrid
          ? this.kbrid
          : this._recurseToHREF(this.state.item_toc[0]); //if no kbrid passed in, then find first in toc
        this.rootnode = { nodes: this.state.item_toc };
        this.selectedNode = undefined;
        this.testOmniRecurse(this.rootnode, null, this.kbrid);
        if (this.selectedNode) {
          util.setOpened(this.selectedNode);
          storeInstance.dispatch("setState", {
            property: "selected_tocitem",
            value: this.selectedNode,
          });
        }

        //util.setParents(this.rootnode);
        this.removeFilter();
        if (this.state.filter_term) {
          this.applyFilter();
        }
        //util.setParents(this.rootnode);
        //this._setSelected(this.rootnode, this.kbrid);
      }
      if (this.state.toc_open) {
        this.leftSideWidthPerc = this.state.global_screen_specs.tocWidthPercent;
        this.rightSideWidthPerc =
          this.state.global_screen_specs.topicWidthPercent;
      } else {
        this.leftSideWidthPerc = 0;
        this.rightSideWidthPerc = 100;
      }
      this.myRender();
    }
  }

  testOmniRecurse(node, parent, selectedKbrid) {
    node.open = false; //handy place to set this default status
    node.selected = false;
    if (parent) {
      node.parent = parent;
    }
    if (selectedKbrid) {
      if (node?.href == selectedKbrid) {
        node.selected = true;
        this.selectedNode = node;
      }
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this.testOmniRecurse(node.nodes[i], node, selectedKbrid);
      }
    } else {
      if (node.children) {
        for (var i = 0; i < node.children.length; i++) {
          this.testOmniRecurse(node.children[i], node, selectedKbrid);
        }
      }
    }
  }

  _setSelected(node, href) {
    node.selected = false;
    if (node.href == href) {
      node.selected = true;
      this.selectedNode = node;
      util.setOpened(this.selectedNode);
      storeInstance.dispatch("setState", {
        property: "selected_tocitem",
        value: node,
      });
    }
    if (node.nodes) {
      for (var i = 0; i < node.nodes.length; i++) {
        this._setSelected(node.nodes[i], href);
      }
    }
  }

  _recurseToHREF(node) {
    if (node.href) {
      return node.href;
    }
    for (var i = 0; i < node.nodes; i++) {
      return this._recurseToHREF(node.nodes[i]);
    }
  }

  myRender() {
    render(this.ipcTemplate(), this.shadowRoot);
    if (!this.helpsetcontainer) {
      this.helpsetcontainer =
        this.shadowRoot.querySelector("#helpsetcontainer");
      this.helpsetcontainer.addEventListener(
        "splitter-dragend",
        this.updateScreenWidthSpecs.bind(this)
      );
    } else {
      if (!this.state.toc_open) {
        var leftPx = 0;
        var rightPx = this.state.global_screen_specs.viewportWidth;
      } else {
        var leftPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.leftSideWidthPerc
        );
        var rightPx = parseInt(
          this.state.global_screen_specs.viewportWidth * this.rightSideWidthPerc
        );
      }
      this.helpsetcontainer.children[0].style.flex = "1 1 " + leftPx + "px";
      this.helpsetcontainer.children[1].style.flex = "1 1 " + rightPx + "px";
    }
  }

  updateScreenWidthSpecs(e) {
    storeInstance.dispatch("setHelpsetLayoutWidths", {
      left: e.currentTarget.children[0].offsetWidth,
      right: e.currentTarget.children[1].offsetWidth,
    });
    storeInstance.dispatch("setState", {
      property: "toc_open",
      value: e.currentTarget.children[0].offsetWidth > 0,
    });
  }

  ipcTemplate() {
    return html` <style>
        #leftside {
          height: ${this.state.global_screen_specs.workspaceHeight}px;
          overflow: auto;
          width: ${this.leftSideWidthPerc}%;
        }
        #rightside {
          height: ${this.state.global_screen_specs.workspaceHeight}px;
          overflow: auto;
          width: ${this.rightSideWidthPerc}%;
        }

        #filter {
          margin: 0.5rem 1.5rem 0.5rem 0;
        }
        #searchbtn {
          padding-left: 1rem;
          cursor: pointer;
        }
        #filterbtn {
          padding-left: 1rem;
          cursor: pointer;
        }
      </style>
      <vaadin-split-layout id="helpsetcontainer">
        <div id="leftside">
          ${this._dematicFilterTemplate()}
          <kb-toc .rootnode="${this.rootnode}" .kbrid="${this.kbrid}"></kb-toc>
        </div>
        <div id="rightside">${this._rightSdideTemplate()}</div>
      </vaadin-split-layout>`;
  }

  /*
    <div id='search'>
                    <iron-icon id="searchbtn" icon="vaadin:close-small" @click="${this._clearsearch.bind(this)}"></iron-icon>
                    <ui5-input id='searchbox' @keyup="${this.checkEnterKey.bind(this)}" placeholder="${this.string["_helpsetsearch"]}" value="${this.state.search_term ? this.state.search_term.searchterm : ''}"></ui5-input>
                    <iron-icon id="searchbtn" icon="vaadin:search" @click="${this._search.bind(this)}"></iron-icon>
                </div>
                */

  _rightSdideTemplate() {
    if (this.searchitem) {
      return html`<kb-searchview id="ipc"></kb-searchview>`;
    } else {
      return html` <kb-ipc-topic .node="${this.selectedNode}"></kb-ipc-topic> `;
    }
  }

  _dematicFilterTemplate() {
    return html` <div id="filter">
      <iron-icon
        id="searchbtn"
        icon="vaadin:close-small"
        @click="${this._clearfilter.bind(this)}"
      ></iron-icon>
      <ui5-input
        id="filterbox"
        @keyup="${this.checkEnterKeyFilter.bind(this)}"
        placeholder="${this.string["_helpsetfilter"]}"
        value="${this.filterTerm ? this.filterTerm : ""}"
      ></ui5-input>
      <iron-icon
        id="filterbtn"
        icon="vaadin:filter"
        @click="${this._filter.bind(this)}"
      ></iron-icon>
    </div>`;
  }

  _clearsearch() {}

  _clearfilter() {
    this.rootnode = null;
    storeInstance.dispatch("setState", {
      property: "filter_term",
      value: null,
    });
  }

  checkEnterKeyFilter(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this._filter();
    }
  }

  _filter() {
    /* no url state for filter */
    if (!this.filterbox) {
      this.filterbox = this.shadowRoot.querySelector("#filterbox");
    }
    this.rootnode = null;
    storeInstance.dispatch("setState", {
      property: "filter_term",
      value: {
        item: this.state.item.item.externalId,
        filterterm: this.filterbox.value,
      },
    });
  }

  checkEnterKey(e) {
    if (e.key === "Enter" || e.keyCode === 13) {
      this._search();
    }
  }

  _search() {
    var searchbox = this.shadowRoot.querySelector("#searchbox");
    history.pushState(
      null,
      null,
      "/kb/" +
        this.state.langCode +
        "/ipcsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
    Router.go(
      "/kb/" +
        this.state.langCode +
        "/ipcsearch/" +
        searchbox.value +
        "/" +
        this.state.item.item.externalId
    );
  }
}

customElements.define("kb-ipc", KbIpc);
